// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.processDetailText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 2.34vw;
  line-height: 2.78vw;
  text-align: center;

  color: #000000;
  display: flex;
  flex-direction: column;
  margin-top: 3.85vw;
  margin-bottom: 4.39vw;
}
.processDetailText .light {
  font-weight: 300;
}
.count {
  width: 1.24vw;
  height: 1.24vw;
  border-radius: 50%;
  background: #f23f79;
  position: relative;
  margin-right: 1.09vw;
  margin-left: 1.46vw;
}
.count p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 0.73vw;
  /* identical to box height, or 200% */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  color: #ffffff;
}
.count_title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.31vw;
  line-height: 1.46vw;
  margin-bottom: 1.09vw;

  color: #000000;
}
.count_info {
  width: 18.81vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 1.09vw;
  line-height: 1.46vw;
  /* or 133% */

  color: #545454;
}
.countText {
  display: flex;
  flex-direction: column;
}
.countAlign {
  display: flex;
  flex-direction: row;
}
.processDetailCardAlign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.processDetailCard {
  display: flex;
  justify-content: space-evenly;
}
.processDetailImage {
  margin-bottom: 2.19vw;
  width: 8.78vw;
}
.processDetailImage img {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .countAlign {
    display: flex;
    align-items: flex-start !important;
  }
  .processDetailText {
    color: #000;
    font-size: 1.3rem;
    font-weight: 500;
    margin-top: 4rem;
  }
  .processDetailText .light {
    color: #000;
    font-size: 1rem;
    font-weight: 400;
    margin-top: 1rem;
    margin-bottom: 1.2rem;
  }
  .processDetailImage {
    width: 4.5rem;
    margin-left: 1.4rem;
  }
  .processDetailCard {
    flex-direction: column;
  }
  .processDetailCardAlign {
    width: 90%;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .count {
    width: 0.9rem;
    height: 0.9rem;
    position: relative;
    margin-right: 0.5rem;
    margin-top: -0.25rem;
  }

  .count p {
    font-size: 0.8rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .count_title {
    color: #000;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .count_info {
    color: #000;
    opacity: 0.9;
    font-size: 0.9rem;
    font-weight: 400;
    width: 13rem;
    line-height: 1.2;
    margin-top: 0.5rem;
  }

  .processDetailCardAlign {
    margin-bottom: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/WebHomePage/ProcessDetail/ProcessDetail.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;;EAEhC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;;EAErB,cAAc;AAChB;AACA;EACE,cAAc;;EAEd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;;EAEZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,kCAAkC;EACpC;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".processDetailText {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 2.34vw;\n  line-height: 2.78vw;\n  text-align: center;\n\n  color: #000000;\n  display: flex;\n  flex-direction: column;\n  margin-top: 3.85vw;\n  margin-bottom: 4.39vw;\n}\n.processDetailText .light {\n  font-weight: 300;\n}\n.count {\n  width: 1.24vw;\n  height: 1.24vw;\n  border-radius: 50%;\n  background: #f23f79;\n  position: relative;\n  margin-right: 1.09vw;\n  margin-left: 1.46vw;\n}\n.count p {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.73vw;\n  /* identical to box height, or 200% */\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n  color: #ffffff;\n}\n.count_title {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.31vw;\n  line-height: 1.46vw;\n  margin-bottom: 1.09vw;\n\n  color: #000000;\n}\n.count_info {\n  width: 18.81vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 1.09vw;\n  line-height: 1.46vw;\n  /* or 133% */\n\n  color: #545454;\n}\n.countText {\n  display: flex;\n  flex-direction: column;\n}\n.countAlign {\n  display: flex;\n  flex-direction: row;\n}\n.processDetailCardAlign {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.processDetailCard {\n  display: flex;\n  justify-content: space-evenly;\n}\n.processDetailImage {\n  margin-bottom: 2.19vw;\n  width: 8.78vw;\n}\n.processDetailImage img {\n  width: 100%;\n}\n\n@media only screen and (max-width: 767px) {\n  .countAlign {\n    display: flex;\n    align-items: flex-start !important;\n  }\n  .processDetailText {\n    color: #000;\n    font-size: 1.3rem;\n    font-weight: 500;\n    margin-top: 4rem;\n  }\n  .processDetailText .light {\n    color: #000;\n    font-size: 1rem;\n    font-weight: 400;\n    margin-top: 1rem;\n    margin-bottom: 1.2rem;\n  }\n  .processDetailImage {\n    width: 4.5rem;\n    margin-left: 1.4rem;\n  }\n  .processDetailCard {\n    flex-direction: column;\n  }\n  .processDetailCardAlign {\n    width: 90%;\n    flex-direction: row;\n    margin-bottom: 1rem;\n  }\n  .count {\n    width: 0.9rem;\n    height: 0.9rem;\n    position: relative;\n    margin-right: 0.5rem;\n    margin-top: -0.25rem;\n  }\n\n  .count p {\n    font-size: 0.8rem;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .count_title {\n    color: #000;\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n\n  .count_info {\n    color: #000;\n    opacity: 0.9;\n    font-size: 0.9rem;\n    font-weight: 400;\n    width: 13rem;\n    line-height: 1.2;\n    margin-top: 0.5rem;\n  }\n\n  .processDetailCardAlign {\n    margin-bottom: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
